
import * as constants from "../../assets/constants";
import {baseApi} from "../BaseApi";


class ImageAnglesApi extends baseApi {

    getList = async () => {
        return await this.get('?app=imageangles&act=getList')
    }

}

export default new ImageAnglesApi(constants.DEBUG?constants.base_url_stage:constants.base_url_prod);


